module.exports = __webpack_public_path__ + "img/question4.9e997e62.png";